import {fromStorage} from 'interactors/statePersistence';

import {initialUiState} from 'store/UI';
import {initialSettingsViewState} from 'store/Settings';
import {initialUserInputState} from 'store/UserInput';

export function createState(): AppState {
  return {
    ...fromStorage(),
    userInput: initialUserInputState,
    settingsView: initialSettingsViewState,
    ui: initialUiState,
  };
}
